import { initializeApp } from "firebase/app";
import {
  createUserWithEmailAndPassword,
  getAuth,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
  setPersistence,
  browserSessionPersistence,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Set up Firebase
const firebaseConfig = {
   apiKey: "AIzaSyBHPmhv_4ktzFDQFDwQyEiQibD_e9MQ3zE",
  authDomain: "web3safe-64ffa.firebaseapp.com",
  projectId: "web3safe-64ffa",
  storageBucket: "web3safe-64ffa.firebasestorage.app",
  messagingSenderId: "35471597620",
  appId: "1:35471597620:web:54796541bee187802d2a61"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth();
const db = getFirestore(app);

const storage = getStorage(app);

// Listen only for logged in state

export {
  app,
  auth,
  db,
  storage,
  onAuthStateChanged,
  signOut,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  browserSessionPersistence,
  setPersistence,
};
